export default function({ store, error, redirect, query }) {
  const { authUser } = store.state.authUser
  if (!authUser || authUser.expirationTime * 1000 <= Date.now()) {
    redirect('/login')
  }
}
